import React from "react";

import ChatPanel from "./ChatPanel";
import {
  query,
  collection as firebaseCollection,
  onSnapshot,
  orderBy,
  where,
  collectionGroup,
} from "firebase/firestore";
import { db } from "../../firebase";
import EntityDonationMessage from "./EntityDonationMessage";

const DonationMessageCard = ({ entityDonation, donationId, t }) => {
  const [chatDrawerState, setChatDrawerState] = React.useState(false);
  const [entityDonations, setEntityDonations] = React.useState([]);
  const [chatId, setChatId] = React.useState();
  const [particularChatDonation, setParticularChatDonation] = React.useState();
  const toggleDrawer = React.useCallback((value) => {
    setChatDrawerState(value);
  }, []);

  React.useEffect(() => {
    const getData = () => {
      let q;
      if (donationId) {
        q = query(
          collectionGroup(
            db,
            "donationInfo"
          ),
          where("donationId", "==", donationId),
          orderBy("updatedDate", "desc")
        );
      } else {
        q = query(
          firebaseCollection(
            db,
            "entityDonationsChat",
            entityDonation.entityDonationChatUid,
            "donationInfo"
          ),
          orderBy("updatedDate", "desc")
        );
      }
      const unsub = onSnapshot(q, (snap) => {
        const arr = [];
        snap.forEach((doc) => {
          arr.push(doc.data());
        });
        setEntityDonations([...arr]);
      });
      return () => {
        unsub();
      };
    };
    entityDonation.entityDonationChatUid && getData();
  }, [entityDonation, donationId]);

  return (
    <React.Fragment>
      {entityDonations.length > 0 &&
        entityDonations.map((item) => (
          <EntityDonationMessage
            item={item}
            setChatId={setChatId}
            entityDonation={entityDonation}
            setParticularChatDonation={setParticularChatDonation}
            setChatDrawerState={setChatDrawerState}
            t={t}
            key={item.chatUid}
          />
        ))}
      <ChatPanel
        chatUid={chatId}
        entityDonation={entityDonation}
        particularChatDonation={particularChatDonation}
        chatdrawerState={chatDrawerState}
        toggleChatDrawer={toggleDrawer}
        t={t}
      />
    </React.Fragment>
  );
};

export default DonationMessageCard;
